import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import CoverageAccordion from "../coverageAccordion/CoverageAccordion";
import CoverageWraper from "./policy.style";
import "./styles.css";

const Accordion = ({ features, selectedFeatures, updateSelectedFeatures }) => {
  const { t } = useTranslation();
  const [groupFeaturesList, setGroupFeaturesList] = useState(
    Array(features.length).fill([])
  );

  const handleGroupFeaturesChange = (index, features) => {
    let groupFeaturesListCopy = JSON.parse(JSON.stringify(groupFeaturesList));
    groupFeaturesListCopy[index] = features;
    setGroupFeaturesList(groupFeaturesListCopy);
    let newFeaturesList = [];
    groupFeaturesListCopy.map((featuresCopy) => {
      if (Array.isArray(featuresCopy)) newFeaturesList.push(...featuresCopy);
    });
    updateSelectedFeatures(newFeaturesList);
  };

  return (
    <CoverageWraper>
      <div className={"container policy"}>
        <div className="row">
          <div className="col-sm-3 coverage">
            <h3>{t("COVERAGE_POLICY.COVERAGE_HEADING")}</h3>
          </div>
          <div className="col-sm-9 ">
            {features.map((feature, index) => {
              const position =
                index == 0
                  ? "first"
                  : index == features.length - 1
                  ? "last"
                  : "";
              return (
                <CoverageAccordion
                  key={index}
                  index={index}
                  extended={index == 0 ? true : false}
                  initialFeatrues={selectedFeatures}
                  name={feature.featureGroupName}
                  subFeatures={feature.featureItems.featureItemsArray}
                  type={
                    feature.featureItems.featureItemsArray[0]
                      .featureControlType === "E"
                      ? "radio"
                      : "checkbox"
                  }
                  topPicked={index == 1 ? true : false}
                  position={position}
                  selectedFeatures={groupFeaturesList[index]}
                  handleChange={handleGroupFeaturesChange}
                />
              );
            })}
          </div>
        </div>
      </div>
    </CoverageWraper>
  );
};

export default Accordion;
